import { FeatureInfo } from "@/components/FeatureInfo";

export default function AIAnalystPublic() {
  return (
    <FeatureInfo
      eyebrow="AI Analyst"
      title="Understand why a setup exists"
      subtitle="The KREONIS AI Analyst explains structured market data in plain English — trend, momentum, volatility, support/resistance, bullish & bearish scenarios and invalidation levels. It never invents prices, news or signals."
      ctaLabel="Open AI Analyst"
      ctaTo="/app/analyst"
      note
      points={[
        { title: "Data-grounded", desc: "The model interprets indicators computed by our engine — never fabricated numbers." },
        { title: "Both scenarios", desc: "Every read presents a bullish AND bearish case with a clear invalidation level." },
        { title: "Risk-first", desc: "Analysis always frames outcomes as probabilistic, with risk considerations up front." },
        { title: "Multi-timeframe", desc: "Ask about 15m to 1D structure and see alignment scored STRONG / MODERATE / WEAK." },
      ]}
    />
  );
}
